import { AxiosPromise } from "axios";
import {
  CloudSearchResponse,
  LocalSearchResponse,
  NetworkSearchResponse
} from "../../services/@types";
import { route } from "../../shim/jsbridge";
import {
  ICloudTotalCountRequest,
  ICloudTotalCountResponse,
  TiCardListResponse,
  TiCardQueryResponse
} from "./@types";
import {
  FetchUrlsInAnalyzingResponse,
  IAdvancedSearchParams,
  INetworkSearchParams,
  IUserListParams
} from "./@types/AdvancedSearch";
import { UserSampleCount } from "./@types/UserList";
import { ValidateQueryResponse } from "./@types/validatequery";
import { AxiosApiWrapper } from "../../services/api/AxiosApiWrapper";

class Api extends AxiosApiWrapper {
  fetchUserList = (
    queryParams: IUserListParams
  ): AxiosPromise<UserSampleCount[]> =>
    this.get(route("sample-search-user-list", {}, queryParams));

  retrieveCloudTotalCount = (
    data: ICloudTotalCountRequest,
    signal: AbortSignal | undefined
  ): AxiosPromise<ICloudTotalCountResponse> =>
    this.post(route("uploads-search-data-count"), data, {
      signal
    });

  retrieveAdvancedSearchSamples = (
    queryParams: IAdvancedSearchParams,
    signal: AbortSignal | undefined
  ): AxiosPromise<LocalSearchResponse | CloudSearchResponse> =>
    this.get(route("uploads-search-data", {}, queryParams), { signal });

  retrieveNetworkSearchData = (
    queryParams: INetworkSearchParams,
    signal: AbortSignal | undefined
  ): AxiosPromise<NetworkSearchResponse> =>
    this.post(route("uploads-search-network"), queryParams, { signal });

  validateQuery = (
    query: string,
    location: string | undefined,
    signal: AbortSignal | undefined
  ): AxiosPromise<ValidateQueryResponse> =>
    this.post(
      route("upload-search-validate-query"),
      { query, location },
      { signal }
    );

  getTiCardList = (
    query: string,
    signal?: AbortSignal
  ): AxiosPromise<TiCardListResponse> =>
    this.get(route("ti-card-list", [], { query }, { signal }));

  getTiCardData = (
    familyName: string,
    signal?: AbortSignal
  ): AxiosPromise<TiCardQueryResponse> =>
    this.get(route("ti-card-get", [familyName], {}, { signal }));

  fetchListOfUrlsInAnalysisStatus =
    (): AxiosPromise<FetchUrlsInAnalyzingResponse> =>
      this.get(route("fetch-urls-in-analysis"));
}

export default new Api();
